import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalCursoEnfermeria = ({ toggleFunction, modalState }) => {
  const formLink = '#formulario-inscripcion'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Curso Enfermería Transoperatorio Instrumentación Quirúrgica</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Fecha de Inscripción</p>
            <p className='fw-normal'>13 de febrero de 2026 hasta 27 de febrero de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Inicio de Clase</p>
            <p className='fw-normal'>28 de febrero de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Lugar</p>
            <p className='fw-normal'>2do Piso Edificio Ciencia y Salud</p>
          </div>

          <a className='btn btn-primary link-button mb-4 disabled' href={formLink} target='blank' hidden>
            Formulario de Inscripción
          </a>

          <div className='info-group mt-3 mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Esp. Edicta Fereira</p>
            <p className='fw-semibold mb-0'>Coordinadora del Curso</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalCursoEnfermeria }